import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainTabBasePathEnum } from '../enums/main-tabs';
import { AffordabilityPageModule } from '../misc/pages/affordability/affordability.module';
import { AmortizationPageModule } from '../misc/pages/amortization/amortization.module';
import { PITIPageModule } from '../misc/pages/piti/piti.module';
import { ShareContactInfoPageModule } from '../misc/pages/share-contact-info/share-contact-info.module';
import { HomePageModule } from './home/home.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    loadChildren: () => ShareContactInfoPageModule,
    path: 'share-contact-info'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.Calculators
    },
    loadChildren: () => PITIPageModule,
    path: 'piti'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.Calculators
    },
    loadChildren: () => AmortizationPageModule,
    path: 'amortization'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.Calculators
    },
    loadChildren: () => AffordabilityPageModule,
    path: 'affordability'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class CalculatorsRoutingModule {}
